import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesTreatmentsListComponent } from './cases-treatments-list/cases-treatments-list.component';
import { CasesTreatmentsDetailComponent } from './cases-treatments-detail/cases-treatments-detail.component';

const routes: Routes = [
    {
        path: 'casesTreatments',
        children: [
            { path: '', component: CasesTreatmentsListComponent }
        ]
    },
    {
        path: 'casesTreatments/:guid',
        children: [
            { path: '', component: CasesTreatmentsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],

    exports: [RouterModule]
})
export class CasesTreatmentsRoutingModule { }
